export const positionRouter = {
  path: '/position',
  name: 'Position',
  component: () => import(/* webpackChunkName: "about" */ '../../views/position.vue')
}
